import { firestore } from '../../firebase.config';
import { createPurgeService } from './purgeCore';

const purgeService = createPurgeService(firestore, {
  tenantCollection: 'tenants',
  collectionOrder: [
    // detail/child data first, master record last
    { collection: 'Catalogue', tenantField: 'tenantId' },
    { collection: 'invoices', tenantField: 'tenantId' },
    { collection: 'UserProfileMaster', tenantField: 'tenantId' },
    { collection: 'tenants', tenantField: null }, // master — doc ID IS the tenant ID, always last
    // QuotationNew intentionally omitted — no confirmed tenant field / no active usage yet.
    // Add it back once quotations are actually wired up with a tenantId field.
  ],
  purgeLogCollection: 'PurgeLogs',
});

export const {
  purgeTenant,
  findTenantsDueForPurge,
  runScheduledPurge,
  getPurgeLogs,
} = purgeService;
